
  import { Component, Vue } from 'vue-property-decorator';
  import RegistrationForm from '@/modules/Auth/components/registration/RegistrationForm.vue';
  import OfertaPopup from "@/modules/Auth/components/OfertaPopup.vue";
  import RegistrationResult from "@/modules/Auth/components/registration/RegistrationResult.vue";
  import {bus} from "@/plugins/bus";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import HomeLogo from "@/modules/Home/components/main/HomeLogo.vue";

  enum RegistrationStep {
    Form = 'form',
    Result = 'result',
  }

  @Component({
    components: {
      HomeLogo,
      RegistrationResult,
      RegistrationForm,
      OfertaPopup,
    }
  })
  export default class PageRegistration extends Vue {
    isLoading: boolean = true;
    registrationStep = RegistrationStep.Form;
    formData = null;

    get stepComponents() {
      return {
        [RegistrationStep.Form]: {component: RegistrationForm, props: {}},
        [RegistrationStep.Result]: {component: RegistrationResult, props: { formData: this.formData, },},
      };
    }

    get registrationPopups() { return this.$store.state.dialog.registration; }
    get selectedStep() { return this.stepComponents[this.registrationStep]; }

    async created() {
      try {
        await this.$store.dispatch('auth/init');
        await this.$store.dispatch('initialized');
        this.isLoading = false;
      }
      catch (error) {
        await this.$store.dispatch('handleError', error);
      }
    }

    async mounted() {
      bus.$on(IAuth.EmitterEvents.RegistrationSuccess, (formData) => {
        this.formData = formData;
        this.registrationStep = RegistrationStep.Result;
      });
    }

    destroyed() {
      bus.$off(IAuth.EmitterEvents.RegistrationSuccess);
    }
  }
